import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActiveTireInteractiveSvgComponent } from '@pso-ui/tyre-active-interactive-svg/active-tire-interactive-svg.component';

@Component({
  selector: 'app-six-wheels-active-tire-interactive-svg',
  templateUrl: './six-wheels-active-tire-interactive-svg.component.html',
  styleUrls: ['./six-wheels-active-tire-interactive-svg.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SixWheelsActiveTireInteractiveSvgComponent extends ActiveTireInteractiveSvgComponent {}
